(() => {
  const initialiseCaseHub = (hub) => {
    if (hub.dataset.caseFilterReady === 'true') return;

    const cards = Array.from(hub.querySelectorAll('[data-case-card]'));
    const buttons = Array.from(hub.querySelectorAll('[data-case-filter]'));
    const materialSelect = hub.querySelector('[data-case-material-filter]');
    const emptyState = hub.querySelector('[data-case-empty]');

    if (!cards.length || !buttons.length || !materialSelect) return;

    let activeCategory = 'all';
    let activeMaterial = 'all';

    const values = (card, key) => (card.dataset[key] || '').split(/\s+/).filter(Boolean);

    const applyFilters = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const categories = values(card, 'caseCategories');
        const materials = values(card, 'caseMaterials');
        const categoryMatches = activeCategory === 'all' || categories.includes(activeCategory);
        const materialMatches = activeMaterial === 'all' || materials.includes(activeMaterial);
        const visible = categoryMatches && materialMatches;

        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount !== 0;
    };

    buttons.forEach((button) => {
      const filter = button.dataset.caseFilter;
      if (filter === 'all') return;

      const hasMatchingCard = cards.some((card) =>
        values(card, 'caseCategories').includes(filter)
      );
      button.hidden = !hasMatchingCard;
    });

    Array.from(materialSelect.options).forEach((option) => {
      if (option.value === 'all') return;
      option.hidden = !cards.some((card) =>
        values(card, 'caseMaterials').includes(option.value)
      );
    });

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.caseFilter;

        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });

        applyFilters();
      });
    });

    materialSelect.addEventListener('change', () => {
      activeMaterial = materialSelect.value;
      applyFilters();
    });

    hub.dataset.caseFilterReady = 'true';
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-case-hub]').forEach(initialiseCaseHub);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
